module.exports = __webpack_public_path__ + "img/teclan.156e48b2.png";